import React from "react";
import ViewChangeKeyPosition from "../../features/ViewChangeKeyPosition/ViewChangeKeyPosition";

const ViewChangeKeyPositionPage = () => {
  return (
    <div className="page-container">
      <ViewChangeKeyPosition />
    </div>
  );
};

export default ViewChangeKeyPositionPage;
